<!-- banner blank space area -->
<div class="rts-banner-area rts-banner-one">
    <div *ngIf="sliders().length > 0" appSwiper [swiperOptions]="swiperOptions()" navigation="true"
        class="swiper mySwiper banner-one">
        <div class="swiper-wrapper">
            @for (slide of sliders(); track $index) {
            <div class="swiper-slide two slider" [ngStyle]="{
        'background-image': 'url(' + (slide?.image?.path! | imageUrl) + ')'
        }" (click)="goToLink(slide?.link!)">
                <!-- banner single content -->
                <div class="banner-one-inner text-end">
                    <p class="pre-title">
                        <!-- <span >{{"SLIDER.TITLE1" | translate}}</span> {{"SLIDER.TITLE2" | translate}} -->
                        <span>{{slide.title}}</span>
                    </p>
                    <!-- <h1 class="title ">{{slide.title}}</h1> -->
                    <p class="disc banner-para fw-bold">
                        {{slide.summary}}
                    </p>
                    <div class="disc banner-para description" [innerHtml]="slide.description | safeHtml">
                        <!-- {{slide.description}} -->
                    </div>
                    @if(slide.titleLink && slide.link) {
                    <a target="_blank" [href]="slide.link"
                        class="rts-btn btn-primary color-h-black">{{slide.titleLink}}</a>
                    }
                    <img class="shape-img one" src="./images/banner/shape/01.png" alt="banner_business">
                </div>
                <!-- banner single content end -->
            </div>
            }
        </div>
        <div class="swiper-pagination"></div>

        <!-- Navigation buttons -->
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>



    </div>
    <div class="animation-img">
        <img class="shape-img two" src="./images/banner/shape/02.png" alt="banner_business">
        <img class="shape-img three" src="./images/banner/shape/03.png" alt="banner_business">
    </div>
</div>
<!-- banner blank space area end -->